"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FormContext_1 = __importDefault(require("../contexts/FormContext"));
exports.default = (function () {
    var _a = react_1.useState({}), values = _a[0], setValues = _a[1];
    var formProps = react_1.useContext(FormContext_1.default).formProps;
    react_1.useEffect(function () {
        if (formProps && formProps.values) {
            setValues(formProps.values);
        }
    }, [formProps]);
    return values;
});
